import React, { useState } from 'react'
import useDialogState from '@/hooks/use-dialog-state'
import { Case } from '../data/schema'

export type CasesDialogType = 'add' | 'edit' | 'delete' | 'archive'

interface CasesContextType {
  open: CasesDialogType | null
  setOpen: (str: CasesDialogType | null) => void
  currentRow: Case | null
  setCurrentRow: React.Dispatch<React.SetStateAction<Case | null>>
  prefillData: any | null
  setPrefillData: React.Dispatch<React.SetStateAction<any | null>>
}

const CasesContext = React.createContext<CasesContextType | null>(null)

interface Props {
  children: React.ReactNode
}

export default function CasesProvider({ children }: Props) {
  const [open, setOpen] = useDialogState<CasesDialogType>(null)
  const [currentRow, setCurrentRow] = useState<Case | null>(null)
  const [prefillData, setPrefillData] = useState<any | null>(null)

  return (
    <CasesContext.Provider value={{ open, setOpen, currentRow, setCurrentRow, prefillData, setPrefillData }}>
      {children}
    </CasesContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useCases = () => {
  const usersContext = React.useContext(CasesContext)

  if (!usersContext) {
    throw new Error('useCases has to be used within <CasesContext>')
  }

  return usersContext
}
